<template>
  <div>
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="文章标题" prop="title" :label-width="formLabelWidth">
        <el-input v-model="form.title" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="原文链接"
        prop="sourceFrom"
        :label-width="formLabelWidth"
      >
        <el-input v-model="form.sourceFrom" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="轮播图片"
        prop="filedId"
        :label-width="formLabelWidth"
      >
        <el-upload
          class="upload-demo"
          :action="action"
          :file-list="fileList"
          :on-success="(response, file) => handleSuccess(response, file)"
          :on-remove="(response, file) => handleRemove(response, file)"
          accept="image/jpg,image/jpeg,image/png"
          :limit="1"
        >
          <el-button size="small" type="primary">上传</el-button>
        </el-upload>
        <!-- <img :src="imgUrl" alt="" srcset="" /> -->
      </el-form-item>
      <el-form-item label="轮播排序" prop="sort" :label-width="formLabelWidth">
        <el-select v-model="form.sort" placeholder="请选择轮播排序">
          <el-option
            v-for="item in issueList"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="文章正文" :label-width="formLabelWidth">
        <div style="border: 1px solid #ccc">
          <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
            :mode="mode"
          />
          <Editor
            style="height: 500px; overflow-y: hidden"
            v-model="form.divInfo"
            :defaultConfig="editorConfig"
            :mode="mode"
            @onCreated="onCreated"
          />
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <!-- <el-button type="primary" @click="handleUpdate(0)">保 存</el-button> -->
      <el-button type="primary" @click="handleUpdate(1)">发 布</el-button>
    </div>
  </div>
</template>

<script>
import baseURL from "@/api/baseUrl.js";
import {
  updateRotation,
  getRotationDetail,
  uploadCover,
  getSysFileInfoPreview,
} from "@/api/api";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
export default {
  components: { Editor, Toolbar },
  props: ["id"],
  data() {
    return {
      form: {
        divInfo: "",
        id: "",
        img: "",
        publishTime: "",
        sort: "",
        sourceFrom: "",
        title: "",
        type: "",
        imgName: "",
      },
      issueList: ["1", "2", "3", "4", "5"],
      formLabelWidth: "130px",
      fileList: [],
      action: baseURL,
      headers: { Authorization: "Bearer " + sessionStorage.getItem("token") },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        // year: [
        //   { required: true, message: "请选择轮播排序", trigger: "change" },
        // ],
        // publishTime: [
        //   {
        //     type: "date",
        //     required: true,
        //     message: "请选择发布时间",
        //     trigger: "change",
        //   },
        // ],
        // filedId: [
        //   {
        //     required: true,
        //     message: "请上传文件",
        //     trigger: "change",
        //   },
        // ],
      },
      editor: null,
      toolbarConfig: {},
      editorConfig: { placeholder: "请输入正文..." },
      mode: "default", // or 'simple'
    };
  },
  mounted() {
    this.handleGetDetail();
  },
  methods: {
    async handleUpdate(status) {
      let flag = false;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          flag = true;
        }
      });
      if (flag) {
        const res = await updateRotation({
          ...this.form,
          id: this.id,
        });
        if (res.data.code === 200) {
          this.$message.success("修改成功");
          this.$parent.$parent.handleClose();
        }
      }
    },
    async handleGetDetail() {
      const res = await getRotationDetail({
        ...this.form,
        id: this.id,
      });
      if (res.data.code === 200) {
        this.form = { ...res.data.data };
        this.fileList.push({ name: this.form.imgName, url: "" });
      }
    },
    handleSuccess(response, file) {
      if (response) {
        const formData = new FormData();
        formData.append("file", file.raw);
        console.log(formData.get("file"));
        uploadCover(formData).then((res) => {
          console.log(res);
          if (res.data) {
            this.form.img = res.data.data;
            this.form.imgName = file.name;
            this.$forceUpdate();
            this.$message.success("文件上传成功");
          }
        });
      }
    },
    handleClose() {
      this.$parent.$parent.handleClose();
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    handleRemove(response, file, fileList) {
      this.imgUrl = "";
    },
    handleBefore(file) {
      return new Promise((resolve, reject) => {
        const suffix =
          file.type === "image/jpg" ||
          file.type === "image/jpeg" ||
          file.type === "image/png";
        if (suffix) {
        }
      });
    },
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>

<style>
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>